// extracted by mini-css-extract-plugin
export default {"rolesPageAuthorizations":"roles_page_rolesPageAuthorizations__amWrz","roleSwitcher":"roles_page_roleSwitcher__UUwqz"};